var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoDeviceData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 88.9",
    style: {
      enableBackground: "new 0 0 120 88.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#EF9D84;}\r\n\t.st2{fill:#FFFFFF;stroke:#272626;stroke-width:0.717;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#272626;stroke-width:0.717;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st4{fill:none;stroke:#F36C3D;stroke-width:0.717;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st5{fill:none;stroke:#F36C3D;stroke-width:0.717;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:1.51,3.02;}\r\n\t.st6{fill:none;stroke:#F36C3D;stroke-width:0.717;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:1.5124,3.0249;}\r\n\t.st7{fill:none;stroke:#F36C3D;stroke-width:0.717;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:1.3946,2.7893;}\r\n\t.st8{fill:none;stroke:#F36C3D;stroke-width:0.717;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:1.4926,2.9853;}\r\n\t.st9{fill:none;stroke:#EF9D84;stroke-width:2.868;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st10{fill:none;stroke:#F36C3D;stroke-width:0.717;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:1.2685,2.5369;}\r\n\t.st11{fill:none;stroke:#F36C3D;stroke-width:0.717;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:1.2262,2.4525;}\r\n\t.st12{fill:none;stroke:#F36C3D;stroke-width:0.717;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st13{fill:none;stroke:#F36C3D;stroke-width:0.717;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:1.393,2.7859;}\r\n\t.st14{fill:none;stroke:#F36C3D;stroke-width:0.717;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:1.3148,2.6295;}\r\n\t.st15{fill:none;stroke:#F36C3D;stroke-width:0.717;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:1.3152,2.6304;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.4,69.2l8.3-7.1l7.7,5.4c1.2,0.8,1.6,2.3,1.1,3.6l-0.4,1l-7.9-4.6l-4,5.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.8,82.1l7.9,6.8l7.7-5.4c1.2-0.8,1.6-2.3,1.2-3.6l-0.4-1l-7.9,4.6l-4.6-6.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.3,72.1l0,6.8c0,2.3-1.9,4.2-4.2,4.2l0,0c-2.3,0-4.2-1.9-4.2-4.2l0-6.8c0-2.3,1.9-4.2,4.2-4.2l0,0 C35.4,67.9,37.3,69.8,37.3,72.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "16.8,69.9 14.3,50.2 13.3,43.1 22.8,43.1 21.6,75.5 17.6,75.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "108.5,75.5 104.5,75.5 103.3,43.1 112.8,43.1 111.8,50.2 109.3,69.9  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "64.1,73.8 64.1,69.8 59.9,76.3 62,76.3 62,80.3 66.2,73.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M84.3,23.1H41.8c-1.2,0-2.1-0.9-2.1-2.1v-8c0-1.2,0.9-2.1,2.1-2.1h42.5c1.2,0,2.1,0.9,2.1,2.1v8 C86.4,22.1,85.5,23.1,84.3,23.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.4,12.8V21c0,1.1-0.9,2-2,2H46.1c-1.1,0-2-0.9-2-2v-8.2c0-1.1,0.9-2,2-2h38.3 C85.5,10.8,86.4,11.7,86.4,12.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "63.9,10.8 54.9,23.1 51.4,23.1 60.4,10.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "77.6,10.8 68.5,23.1 58.1,23.1 67.1,10.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M45.2,3.1H90c2.7,0,4.9,2.2,4.9,4.9v42.7c0,2.7-2.2,4.9-4.9,4.9H36.1c-2.7,0-4.9-2.2-4.9-4.9V7.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M84.3,23.1H41.8c-1.2,0-2.1-0.9-2.1-2.1v-8c0-1.2,0.9-2.1,2.1-2.1h42.5c1.2,0,2.1,0.9,2.1,2.1v8 C86.4,22.1,85.5,23.1,84.3,23.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "47.2,2.3 47.2,3.1 47.9,3.1  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 51,
    y1: 3.1,
    x2: 76.6,
    y2: 3.1
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "78.1,3.1 78.9,3.1 78.9,2.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M77.4,0c-0.1,0-0.2,0-0.3,0H49c-0.6,0-1.2,0.3-1.5,0.9"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "66.6,44.6 69.7,44.6 71.2,42.3 71.2,47 72.8,44.6 75.9,44.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M75.7,51.1h-8.9c-1.5,0-2.8-1.2-2.8-2.8v-7.4c0-1.5,1.2-2.8,2.8-2.8h8.9c1.5,0,2.8,1.2,2.8,2.8v7.4 C78.5,49.9,77.2,51.1,75.7,51.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M55.1,28.4c2.3,1.4,3,4.4,1.6,6.7c-1.4,2.3-4.4,3-6.7,1.6c-2.3-1.4-3-4.4-1.6-6.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.5,32.6c0,1.7-1.3,3-3,3c-1.7,0-3-1.3-3-3c0-1.7,1.3-3,3-3C54.2,29.6,55.5,31,55.5,32.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M52.2,51.1c-2.7-0.2-4.7-2.5-4.6-5.2c0.2-2.7,2.5-4.7,5.2-4.6c2.7,0.2,4.7,2.5,4.6,5.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.5,46.3c0,1.7-1.3,3-3,3c-1.7,0-3-1.3-3-3c0-1.7,1.3-3,3-3C54.2,43.3,55.5,44.6,55.5,46.3z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M29.3,29.3h1.9V11.6h-1.9c-0.9,0-1.5,0.7-1.5,1.5v14.6C27.7,28.6,28.4,29.3,29.3,29.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M96.8,29.3h-1.9V11.6h1.9c0.9,0,1.5,0.7,1.5,1.5v14.6C98.3,28.6,97.7,29.3,96.8,29.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M31.2,7.9c0-0.2,0-0.5,0.1-0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M32.4,4.7c0.9-1,2.2-1.7,3.7-1.7h7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 44.5,
    y1: 3.1,
    x2: 45.2,
    y2: 3.1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 54.1,
    y1: 60.4,
    x2: 54.8,
    y2: 60.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 57.8,
    y1: 60.4,
    x2: 69.8,
    y2: 60.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 71.3,
    y1: 60.4,
    x2: 72,
    y2: 60.4
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M77.2,31.2H65.3c-0.7,0-1.3,0.6-1.3,1.3l0,0c0,0.7,0.6,1.3,1.3,1.3h11.9c0.7,0,1.3-0.6,1.3-1.3l0,0 C78.5,31.8,77.9,31.2,77.2,31.2z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 86.4,
    y1: 34.1,
    x2: 86.4,
    y2: 45.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 39.7,
    y1: 34.1,
    x2: 39.7,
    y2: 45.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 32.8,
    y1: 35.8,
    x2: 31.2,
    y2: 35.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 32.8,
    y1: 40.8,
    x2: 31.2,
    y2: 40.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 32.8,
    y1: 45.7,
    x2: 31.2,
    y2: 45.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 32.8,
    y1: 50.7,
    x2: 31.2,
    y2: 50.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 94.9,
    y1: 35.8,
    x2: 93.3,
    y2: 35.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 94.9,
    y1: 40.8,
    x2: 93.3,
    y2: 40.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 94.9,
    y1: 45.7,
    x2: 93.3,
    y2: 45.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 94.9,
    y1: 50.7,
    x2: 93.3,
    y2: 50.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "24.7,38.7 31.2,38.7 31.2,47.5 24.7,47.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "101.3,38.7 94.9,38.7 94.9,47.5 101.3,47.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.4,72.1h-8.6c-1,0-1.9,0.8-1.9,1.9v3c0,1,0.8,1.9,1.9,1.9h8.6c1,0,1.9-0.8,1.9-1.9v-3 C56.3,73,55.4,72.1,54.4,72.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.8,72.1l0,6.8c0,2.3,1.9,4.2,4.2,4.2l0,0c2.3,0,4.2-1.9,4.2-4.2l0-6.8c0-2.3-1.9-4.2-4.2-4.2l0,0 C90.7,67.9,88.8,69.8,88.8,72.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.8,
    y: 71.4,
    className: "st0",
    width: 3,
    height: 8.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.3,79.1l4.4,1.6c1,0.4,2.1-0.4,2.1-1.5v-7.4c0-1.1-1.1-1.9-2.1-1.5l-4.4,1.6V79.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.3,77.9h-4.2c-0.6,0-1.2-0.5-1.2-1.2v-2.5c0-0.6,0.5-1.2,1.2-1.2h4.2V77.9z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "13.3,43.1 22.8,43.1 21.6,75.5 17.6,75.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 41.2,
    y1: 83.5,
    x2: 40.8,
    y2: 82.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 39.3,
    y1: 80.9,
    x2: 37.8,
    y2: 78.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 37.1,
    y1: 77.8,
    x2: 36.7,
    y2: 77.2
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.8,82.1l7.9,6.8l7.7-5.4c1.2-0.8,1.6-2.3,1.2-3.6l-0.4-1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M36.2,66l4.5-3.9l7.7,5.4c1.2,0.8,1.6,2.3,1.1,3.6l-0.4,1l-7.9-4.6l-4,5.5"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 49.2,
    y1: 78.9,
    x2: 41.2,
    y2: 83.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.3,76.3l0,2.6c0,2.3-1.9,4.2-4.2,4.2l0,0c-2.3,0-4.2-1.9-4.2-4.2l0-2.6c0-2.3,1.9-4.2,4.2-4.2l0,0 C35.4,72.1,37.3,74,37.3,76.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M37.3,72.1l0,6.8c0,2.3-1.9,4.2-4.2,4.2l0,0c-2.3,0-4.2-1.9-4.2-4.2l0-6.8c0-2.3,1.9-4.2,4.2-4.2l0,0 C35.4,67.9,37.3,69.8,37.3,72.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 33.1,
    y1: 79.3,
    x2: 33.1,
    y2: 78.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 33.1,
    y1: 76.1,
    x2: 33.1,
    y2: 73.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 33.1,
    y1: 72.4,
    x2: 33.1,
    y2: 71.7
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M19.6,74.4l0,2.1c0,1.4,1.1,2.6,2.6,2.6l6.8,0l0-7.2l-6.8,0C20.7,71.9,19.6,73,19.6,74.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M54.4,78.9h-8.6c-1,0-1.9-0.8-1.9-1.9v-3c0-1,0.8-1.9,1.9-1.9h8.6c1,0,1.9,0.8,1.9,1.9v3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25.8,75.5c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2C23,69.2,25.8,72,25.8,75.5z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.6,77.9c-1.3,0-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4c1.3,0,2.4,1.1,2.4,2.4 C22,76.8,20.9,77.9,19.6,77.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.1,35.1c-4.4,0-8,3.6-8,8c0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8C26.1,38.7,22.5,35.1,18.1,35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M26.1,43.1c0,4.4-3.6,8-8,8c-4.4,0-8-3.6-8-8c0-4.4,3.6-8,8-8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.1,46.2c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1c1.7,0,3.1,1.4,3.1,3.1 C21.1,44.8,19.7,46.2,18.1,46.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M18.1,35.1c0.2,0,0.5,0,0.7,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M21.4,35.9c2.1,1,3.7,2.9,4.3,5.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M26,42.4c0,0.2,0,0.5,0,0.7"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M15.4,31.7c-2.6,0.6-4.8,2-6.4,4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M14.6,28.1c-3.4,0.8-6.3,2.7-8.5,5.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.8,76.3l0,2.6c0,2.3,1.9,4.2,4.2,4.2l0,0c2.3,0,4.2-1.9,4.2-4.2l0-2.6c0-2.3-1.9-4.2-4.2-4.2l0,0 C90.7,72.1,88.8,74,88.8,76.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M88.8,72.1l0,6.8c0,2.3,1.9,4.2,4.2,4.2l0,0c2.3,0,4.2-1.9,4.2-4.2l0-6.8c0-2.3-1.9-4.2-4.2-4.2l0,0 C90.7,67.9,88.8,69.8,88.8,72.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 93,
    y1: 79.3,
    x2: 93,
    y2: 78.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 93,
    y1: 76.1,
    x2: 93,
    y2: 73.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 93,
    y1: 72.4,
    x2: 93,
    y2: 71.7
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 85.8,
    y: 71.4,
    className: "st3",
    width: 3,
    height: 8.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M79.3,79.1l4.4,1.6c1,0.4,2.1-0.4,2.1-1.5v-7.4c0-1.1-1.1-1.9-2.1-1.5l-4.4,1.6V79.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M79.3,77.9h-4.2c-0.6,0-1.2-0.5-1.2-1.2v-2.5c0-0.6,0.5-1.2,1.2-1.2h4.2V77.9z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 73.9,
    y1: 75.5,
    x2: 69.6,
    y2: 75.5
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "108.5,75.5 104.5,75.5 103.3,43.1 112.8,43.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108,35.1c-4.4,0-8,3.6-8,8c0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8C116,38.7,112.5,35.1,108,35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M116,43.1c0,4.4-3.6,8-8,8c-4.4,0-8-3.6-8-8c0-4.4,3.6-8,8-8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M108,46.2c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1c1.7,0,3.1,1.4,3.1,3.1 C111.1,44.8,109.7,46.2,108,46.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M106.5,74.4l0,2.1c0,1.4-1.1,2.6-2.6,2.6l-6.8,0l0-7.2l6.8,0C105.4,71.9,106.5,73,106.5,74.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M100.3,75.5c0,3.4,2.8,6.2,6.2,6.2c3.4,0,6.2-2.8,6.2-6.2c0-3.4-2.8-6.2-6.2-6.2 C103.1,69.2,100.3,72,100.3,75.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.5,77.9c-1.3,0-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4c1.3,0,2.4,1.1,2.4,2.4 C108.9,76.8,107.8,77.9,106.5,77.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M108,35.1c0.2,0,0.5,0,0.7,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M111.4,35.9c2.1,1,3.7,2.9,4.3,5.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M116,42.4c0,0.2,0,0.5,0,0.7"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M117.1,35.7c-1.6-2-3.9-3.4-6.4-4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M120,33.4c-2.1-2.6-5.1-4.5-8.5-5.3"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "st12",
    points: "24.7,38.7 31.2,38.7 31.2,47.5 24.7,47.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st12",
    points: "101.3,38.7 94.9,38.7 94.9,47.5 101.3,47.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 16.8,
    y1: 69.9,
    x2: 16.7,
    y2: 69.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 16.4,
    y1: 66.6,
    x2: 14.5,
    y2: 52.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 14.3,
    y1: 50.9,
    x2: 14.3,
    y2: 50.2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 111.8,
    y1: 50.2,
    x2: 111.7,
    y2: 50.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 111.4,
    y1: 53.5,
    x2: 109.5,
    y2: 67.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 109.4,
    y1: 69.2,
    x2: 109.3,
    y2: 69.9
  })))), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 98.3,
    y1: 17.7,
    x2: 98.3,
    y2: 23.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 27.7,
    y1: 17.7,
    x2: 27.7,
    y2: 23.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDeviceData);
export default __webpack_public_path__ + "static/media/no-device-data.3350f60ed6816e77a59583de9863e1ea.svg";
export { ForwardRef as ReactComponent };